import React, { lazy, Suspense } from 'react';
import { Loading } from 'react-admin';

// Lazily import the ProductBlacklistList component
const ProductBlacklistList = lazy(() => import('./ProductBlacklistList'));

// Define a component to handle the loading fallback
const Loader = () => <Loading />;

// Wrap the lazy component in Suspense when it's used
const ProductBlackListComp = {
  list: () => (
    <Suspense fallback={<Loader />}>
      <ProductBlacklistList />
    </Suspense>
  )
};

export default ProductBlackListComp;
